import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import tmpl from '../../template/sidebar/aggregate-length.pug';

/**
 * Define view of aggregate length
 * @private
 * @param {String[]} properties - aggregate property list
 * @param {Object} viewModel - model of property
 * @param {String} id - unique string as id
 * @param {I18n} i18n - provide callback function getString
 */
export class AggregateLength extends Backbone.View {
  initialize({
    properties = [], viewModel = {}, id, i18n,
  } = {}) {
    const strProperties = properties.toString();

    this.srId = `${id}-TotalRemaining`;

    _.each(properties, (property) => {
      viewModel[property].describedby.push(this.srId);
    });

    this.viewModel = {
      remaining: viewModel[strProperties].remaining,
      remainingChar: ko.computed(() => {
        const remaining = viewModel[strProperties].remaining();
        const fields = _.reduce(properties, (initial, property) => {
          if (initial) {
            return i18n.getString('SimpleForm_TotalRemainingCharactersText_FieldsList', {
              initial,
              last: viewModel[property].label(),
            });
          }
          return viewModel[property].label();
        });

        return i18n.getString('SimpleForm_TotalRemainingCharactersText', {
          count: remaining,
          fields,
        });
      }),
    };
  }

  render() {
    this.$el.html(tmpl({ srId: this.srId }));

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }
}
